/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeAiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_AI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeAiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeAiEnabledSettingParser.decode(input).map(res => new TierFreeAiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeAiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeAiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeAiEnabledSettingParser.schema();
    }
}
